<template>
    <div>
        <LayoutHeader :hideMenu="true"/>
        <WrapBg title="找回密码" bgImg="myBg" color="#303133">
            <div class="forgot">
                <el-breadcrumb separator-class="el-icon-arrow-right" class="mb-15">
                    <el-breadcrumb-item :to="{ path: '/login' }">登录页面</el-breadcrumb-item>
                    <el-breadcrumb-item>找回密码</el-breadcrumb-item>
                </el-breadcrumb>
                <el-steps :active="active" finish-status="success" simple>
                    <el-step title="填写账号"></el-step>
                    <el-step title="问题验证"></el-step>
                    <el-step title="重置密码"></el-step>
                </el-steps>
                <div class="text-center" >
                    <el-form label-width="100px" label-position="left" style="width:330px;margin:30px auto;">
                        <div v-show="active==0">
                            <el-input v-model="empno" placeholder="登录账号"></el-input>
                            <div class="mt-15"><el-button type="primary" @click="next1"> 下 一 步 </el-button></div>
                        </div>
                        <div v-show="active==1">
                            <div v-if="!questionStatus" class="text-center">
                                <div>未设置安全问题无法找回密码</div>
                            </div>
                            <div v-else>
                                <el-select v-model="questionId" placeholder="请选择问题" style="width:100%;">
                                    <el-option v-for="item in questionList" :key="item.questionId" :label="item.questionName" :value="item.questionId"></el-option>
                                </el-select>
                                <el-input v-model="answer" class="mt-15" type="text" placeholder="答案"></el-input>
                                <div class="mt-15 text-center">
                                    <el-button type="primary" plain @click="active-=1"> 上 一 步 </el-button>
                                    <el-button type="primary" @click="next2"> 下 一 步 </el-button>
                                </div>
                            </div>
                        </div>
                        <div v-show="active==2">
                            <el-input v-model="newPassword" maxlength="6" onkeyup="value=value.replace(/[^\d]/g,'')" placeholder="6位数字新密码" type="password"></el-input>
                            <el-input v-model="confirmPassword" maxlength="6" onkeyup="value=value.replace(/[^\d]/g,'')" class="mt-15" placeholder="确认密码" type="password"></el-input>
                            <div class="mt-15 text-center">
                                <el-button type="primary" plain @click="active-=1">上一步</el-button>
                                <el-button type="primary" @click="save">保存</el-button>
                            </div>
                        </div>
                    </el-form>
                </div>
            </div>
        </WrapBg>
    </div>
</template>

<script>
    import LayoutHeader from '../components/LayoutHeader';
    export default {
        name: "Forgot",
        data(){
            return{
                active:0,
                empno:'',//账号
                questionStatus:true,//是否已设置问题
                questionList:[],
                questionId:'',
                answer:'',
                newPassword:'',
                confirmPassword:'',
                ticket:'',
            }
        },
        components:{LayoutHeader},
        methods:{
            async next1(){
                if(!this.empno) return this.$message.warning('请输入登录账号');
                const loading = this.$loading({background: 'rgba(0, 0, 0, 0.3)'});
                let res = await this.$api.accountVerify({method:'member', devId: 'WEB',empno:this.empno});
                if(!res || !res.data) return;
                let data = res.data;
                loading.close();
                if (data.respCode === '0000') {
                    this.active = 1;
                    this.ticket = data.obj;
                    this.getQuestion();
                } else {
                    this.$message.error(data.respInfo);
                }
            },
            async getQuestion(){
                let res = await this.$api.questionAvoid({
                    method:'member', devId: 'WEB',
                    empno: this.empno
                });
                if(!res || !res.data) return;
                let data = res.data;
                if(data.respCode === '0000'){
                    if(data.objs && data.objs.length>0){
                        this.questionList = data.objs;
                    }else{
                        this.questionStatus = false;
                    }
                }else{
                    this.$message.error(data.respInfo);
                }
            },
            async next2(){
                if(!this.questionId || !this.answer){
                    return this.$message.warning('请先选择问题，并回答')
                }
                let list = [{questionId:this.questionId,answer:this.answer},];
                const loading = this.$loading({background: 'rgba(0, 0, 0, 0.3)'});
                let res = await this.$api.verifyForPW({
                    method:'member', devId: 'WEB',
                    list:JSON.stringify(list),
                    empno:this.empno,
                    ticket:this.ticket,
                });
                if(!res || !res.data) return;
                let data = res.data;
                loading.close();
                if(data.respCode === '0000'){
                    this.active = 2;
                }else{
                    this.$message.error(data.respInfo);
                }
            },
            async save(){
                let newPassword = this.newPassword, confirmPassword = this.confirmPassword;
                if(!newPassword){
                    return this.$message.warning('请输入新密码');
                }else if(!confirmPassword){
                    return this.$message.warning('请输入确认密码');
                }else if(newPassword !== confirmPassword){
                    return this.$message.warning('新密码和确认密码不一致');
                }
                const loading = this.$loading({background: 'rgba(0, 0, 0, 0.3)'});
                let key = '';
                let e = await this.$api.loginAdvance();
                if(!e || !e.data) return;
                let keyData = e.data;
                if(keyData.respCode === '0000'){
                    key = keyData.obj;
                }else {
                    return this.$message.error(data.respInfo);
                }
                let password = await this.$encryptedData(key.publicKey,newPassword);
                let res = await this.$api.retrievePassword({
                    method: 'member', devId: 'WEB',
                    empno:this.empno,
                    newPassword: password,
                    ticket:this.ticket,
                    sessionId:key.securityId,
                });
                if(!res || !res.data) return;
                let data = res.data;
                loading.close();
                if (data.respCode === '0000') {
                    this.$message.success('密码修改成功');
                    this.$router.push('/login');
                } else {
                    this.$message.error(data.respInfo);
                }
            }
        }
    }
</script>

<style lang="less" scoped>
    .forgot{
        width:700px;
        margin:15px auto;
    }
</style>